import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, trackView, resolveImg } from "../lib/api";
import SEO from "../components/SEO";
import { Calendar, ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => { trackView(`/blog/${slug}`); }, [slug]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/blog/${slug}`);
        setPost(data);
      } catch { setError(true); }
    })();
  }, [slug]);

  if (error) return (
    <div className="pt-32 pb-24 bg-[#09090b] text-white min-h-screen">
      <div className="max-w-[800px] mx-auto px-6 text-center">
        <p className="text-zinc-500">Article introuvable.</p>
        <Link to="/blog" className="text-[#d4af37] mt-4 inline-block link-gold">← Retour au journal</Link>
      </div>
    </div>
  );
  if (!post) return <div className="pt-32 bg-[#09090b] min-h-screen" />;

  return (
    <div className="pt-32 pb-24 bg-[#09090b] text-white min-h-screen">
      <SEO
        title={post.seo_title || post.title}
        description={post.seo_description || post.excerpt}
        keywords={post.tags?.join(", ")}
        image={post.cover_image ? resolveImg(post.cover_image) : undefined}
        type="article"
        article={{ published_at: post.created_at, tags: post.tags }}
      />
      <article className="max-w-3xl mx-auto px-6">
        <Link to="/blog" className="text-zinc-500 text-sm inline-flex items-center gap-2 hover:text-white mb-10" data-testid="back-to-blog">
          <ArrowLeft size={14} /> Retour au journal
        </Link>
        <div className="text-xs tracking-[0.2em] text-[#d4af37] uppercase mb-4 flex items-center gap-3">
          <Calendar size={12} />
          {new Date(post.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}
          {post.tags?.length > 0 && <span className="text-zinc-600">— {post.tags.join(", ")}</span>}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-8" data-testid="blog-post-title">
          {post.title}
        </h1>
        {post.cover_image && (
          <img src={resolveImg(post.cover_image)} alt={post.title} className="w-full aspect-[16/9] object-cover mb-10 border border-white/10" />
        )}
        <div className="prose prose-invert prose-zinc max-w-none text-zinc-300 leading-relaxed font-light whitespace-pre-wrap" data-testid="blog-post-content">
          {post.content}
        </div>
      </article>
    </div>
  );
}
